/**
    This file is autogenerated using the command `yarn app-store:build --watch`.
    Don't modify this file manually.
**/
import { appDataSchema as googlecalendar_zod_ts } from "./googlecalendar/zod";
import { appDataSchema as office365calendar_zod_ts } from "./office365calendar/zod";
import { appDataSchema as routing_forms_zod_ts } from "./routing-forms/zod";
import { appDataSchema as stripepayment_zod_ts } from "./stripepayment/zod";
import { appDataSchema as zapier_zod_ts } from "./zapier/zod";
import { appDataSchema as zoomvideo_zod_ts } from "./zoomvideo/zod";

export const appDataSchemas = {
  googlecalendar: googlecalendar_zod_ts,
  office365calendar: office365calendar_zod_ts,
  "routing-forms": routing_forms_zod_ts,
  stripe: stripepayment_zod_ts,
  zapier: zapier_zod_ts,
  zoomvideo: zoomvideo_zod_ts,
};
